<template>
  <div>
    <Head :title="organizationType.name" />
    <h1 class="mb-8 text-3xl font-bold">
      Master
      <span class="font-medium text-indigo-400"> / </span>
      {{ organizationType.name }}
    </h1>
    <div class="flex justify-between items-center mb-6">
      <search-filter
        v-model="form.search"
        :show-dropdown="false"
        class="mr-4 w-full max-w-md"
        @reset="reset" />
      <div class="flex gap-x-2">
        <Link class="btn-indigo" :href="`/organizations/${organizationType.type}/create`">
          <span>Create</span>
          <span class="hidden md:inline">&nbsp;{{ organizationType.name }}</span>
        </Link>
        <button class="btn-green" @click.prevent="exportData">
          <span>Export</span>
        </button>
      </div>
    </div>
    <div class="overflow-x-auto bg-white rounded-md shadow">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="font-bold text-left">
            <th class="px-6 pt-6 pb-4">
              Name
            </th>
            <th v-if="$page.props.organizationType.type === '1'" class="px-6 pt-6 pb-4">
              Code
            </th>
            <th class="px-6 pt-6 pb-4">
              Phone
            </th>
            <th class="px-6 pt-6 pb-4">
              Address
            </th>
            <th class="px-6 pt-6 pb-4">
              City
            </th>
            <th class="px-6 pt-6 pb-4" colspan="2">
              Description
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="organization in organizations.data"
            :key="organization.id"
            class="focus-within:bg-gray-100 hover:bg-gray-100">
            <td class="whitespace-normal border-t">
              <Link
                class="flex items-center py-4 px-6 focus:text-indigo-500"
                :href="`/organizations/edit/${organization.id}`">
                {{ organization.name }}
                <icon
                  v-if="organization.deleted_at"
                  name="trash"
                  class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
              </Link>
            </td>
            <td v-if="organization.organization_type_id === 1" class="border-t">
              <Link
                class="flex items-center py-4 px-6"
                :href="`/organizations/edit/${organization.id}`"
                tabindex="-1">
                {{ organization.code }}
              </Link>
            </td>
            <td class="border-t">
              <Link
                class="flex items-center py-4 px-6"
                :href="`/organizations/edit/${organization.id}`"
                tabindex="-1">
                {{ organization.phone }}
              </Link>
            </td>
            <td class="whitespace-normal border-t">
              <Link
                class="flex items-center py-4 px-6"
                :href="`/organizations/edit/${organization.id}`"
                tabindex="-1">
                {{ organization.address }}
              </Link>
            </td>
            <td class="border-t">
              <Link
                class="flex items-center py-4 px-6"
                :href="`/organizations/edit/${organization.id}`"
                tabindex="-1">
                {{ organization.city }}
              </Link>
            </td>
            <td class="whitespace-normal border-t">
              <Link
                class="flex items-center py-4 px-6"
                :href="`/organizations/edit/${organization.id}`"
                tabindex="-1">
                {{ organization.descriptions }}
              </Link>
            </td>
            <td class="w-px border-t">
              <Link
                class="flex items-center px-4"
                :href="`/organizations/edit/${organization.id}`"
                tabindex="-1">
                <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
              </Link>
            </td>
          </tr>
          <tr v-if="organizations.data.length === 0">
            <td class="py-4 px-6 border-t" colspan="4">
              No organizations found.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="organizations.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
    components: {
        Head,
        Icon,
        Link,
        Pagination,
        SearchFilter,
    },
    layout: Layout,
    props: {
        filters: Object,
        organizations: Object,
        organizationType: Object,
    },
    data () {
        return {
            form: {
                search: this.filters.search,
            },
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                this.$inertia.get(`/organizations/${this.organizationType.type}`, pickBy(this.form), { preserveState: true })
            }, 150),
        },
    },
    methods: {
        reset () {
            this.form = mapValues(this.form, () => null)
        },
        exportData () {
            const param = new URLSearchParams(pickBy(this.form))
            const url = `/organizations/${this.organizationType.type}/export${param.toString() && `?${param}`}`

            window.open(url, '_blank')
        },
    },
}
</script>
